<mat-card class="container-fluid">
  <!-- <mat-card-header class="mb-4">
      <mat-card-title class="mat-card-title-custom text-primary">{{'title.enterprise_list' | translate}}
      </mat-card-title>
  </mat-card-header> -->
  <mat-card-content style="padding-bottom: 0.75rem;">
    <div class="row" style="padding-right: 0.75rem; justify-content: flex-end" *ngIf="isShowWarningExpireContractQuantity ||
                isContractQuantityExpired ||
                isShowWarningExpireDigContract ||
                isStorageDigContractExpired ||
                isShowWarningExpireContract1MBQuantity || 
                (me && me.isWarning)
                ">
      <!-- Cảnh báo gộp  -->
      <div class="col-md-12 pr-0 notify-card" *ngIf="((isShowWarningExpireContractQuantity && !isContractQuantityExpired && isShowWarningExpireDigContract)
        || (isShowWarningExpireContractQuantity && isStorageDigContractExpired) || (isContractQuantityExpired && isShowWarningExpireDigContract)
        || (isContractQuantityExpired && isStorageDigContractExpired)) && !(((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) && isBuyContract1Mb) 
        && !((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) 
        && isBuyContract1Mb 
        && !isShowWarningExpireContractQuantity 
        && !isShowWarningExpireDigContract))">
        <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
          <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
            <div class="d-flex">
              <div style="padding-right: 10px;">
                <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-3 pl-2">
                <span *ngIf="isContractQuantityExpired && isStorageDigContractExpired" class="font15"
                      style="color: red;">
                  {{'analysis.analysis_report_enterprise.notify_both_resouce_contract_expired' | translate}}</span>
                <span *ngIf="isContractQuantityExpired && !isStorageDigContractExpired" class="font15"
                      style="color: red;">
                  {{'analysis.analysis_report_enterprise.notify_contract_quantity_expired' | translate}}
                  {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' |
                  translate}}{{storageDigContractExpireTitle}} .&nbsp;</span>
                <span *ngIf="!isContractQuantityExpired && isStorageDigContractExpired" class="font15"
                      style="color: red;">
                  {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' |
                  translate}}{{ContractQuantityExpireTitle}}.&nbsp;
                  {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expired' | translate}}</span>
                <span *ngIf="!isContractQuantityExpired && !isStorageDigContractExpired" class="font15"
                      style="color: red;">
                  {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' |
                  translate}}{{ContractQuantityExpireTitle}}.&nbsp;
                  {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' |
                  translate}}{{storageDigContractExpireTitle}}.&nbsp;</span>
                <span>{{'analysis.analysis_report_enterprise.notify_contract_expire_end' | translate}}</span>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>

          <!-- Cảnh báo gộp hợp đồng 1MB  -->
          <div class="col-md-12 pr-0 notify-card" *ngIf="((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) && isBuyContract1Mb) 
          && !((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) 
          && isBuyContract1Mb 
          && !isShowWarningExpireContractQuantity 
          && !isShowWarningExpireDigContract)">
            <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
              <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
                <div class="d-flex">
                  <div style="padding-right: 10px;">
                    <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
                  </div>
                  <div class="flex-grow-3 pl-2">
                    <!-- 10MB và 1MB -->
                    <span *ngIf="isContractQuantityExpired && isContract1MBQuantityExpired && !isShowWarningExpireDigContract" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_both_resouce_contract_10mb_and_1mb_expired' | translate}}</span>
                    <span *ngIf="!isContractQuantityExpired && isShowWarningExpireContractQuantity && !isContract1MBQuantityExpired && !isShowWarningExpireDigContract" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' | translate}}
                      {{ContractQuantityExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <span *ngIf="!isContractQuantityExpired && isShowWarningExpireContractQuantity && isContract1MBQuantityExpired && !isShowWarningExpireDigContract" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' | translate}}
                      {{ContractQuantityExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expired' | translate}}
                    </span>
                    <span *ngIf="isContractQuantityExpired && !isContract1MBQuantityExpired && !isStorageDigContractExpired && !isShowWarningExpireDigContract" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expired' | translate}}
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <!-- 1MB và số hóa  -->
                    <span *ngIf="isContract1MBQuantityExpired && isStorageDigContractExpired && !isShowWarningExpireContractQuantity" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_both_resouce_contract_digital_and_1mb_expired' | translate}}</span>
                    <span *ngIf="!isContract1MBQuantityExpired && !isStorageDigContractExpired && !isShowWarningExpireContractQuantity" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' | translate}}
                      {{storageDigContractExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <span *ngIf="!isStorageDigContractExpired && isShowWarningExpireDigContract && isContract1MBQuantityExpired && !isShowWarningExpireContractQuantity" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' | translate}}
                      {{storageDigContractExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expired' | translate}}
                    </span>
                    <span *ngIf="isStorageDigContractExpired && !isContract1MBQuantityExpired && !isShowWarningExpireContractQuantity" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expired' | translate}}
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <!-- 10MB, 1MB và số hóa -->
                    <span *ngIf="isContractQuantityExpired && isContract1MBQuantityExpired && isStorageDigContractExpired" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_both_resouce_contract_10mb_and_1mb_and_digital_expired' | translate}}
                    </span>
                    <span *ngIf="!isContractQuantityExpired && isShowWarningExpireContractQuantity && !isContract1MBQuantityExpired && isShowWarningExpireContract1MBQuantity && !isStorageDigContractExpired && isShowWarningExpireDigContract" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' | translate}}
                      {{ContractQuantityExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' | translate}}
                      {{storageDigContractExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <span *ngIf="!isContractQuantityExpired && isShowWarningExpireContractQuantity && !isStorageDigContractExpired && isShowWarningExpireDigContract && isContract1MBQuantityExpired" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' | translate}}
                      {{ContractQuantityExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' | translate}}
                      {{storageDigContractExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expired' | translate}}
                    </span>
                    <span *ngIf="!isContractQuantityExpired && isShowWarningExpireContractQuantity && isStorageDigContractExpired && isContract1MBQuantityExpired" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' | translate}}
                      {{ContractQuantityExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_both_resouce_contract_digital_and_1mb_expired' | translate}}
                    </span>
                    <span *ngIf="isContractQuantityExpired && !isStorageDigContractExpired && isShowWarningExpireDigContract && isContract1MBQuantityExpired" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_both_resouce_contract_10mb_and_1mb_expired' | translate}}
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' | translate}}
                      {{storageDigContractExpireTitle}}.&nbsp;
                    </span>
                    <span *ngIf="isContractQuantityExpired && isStorageDigContractExpired && !isContract1MBQuantityExpired && isShowWarningExpireContract1MBQuantity" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_both_resouce_contract_expired' | translate}}
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <span *ngIf="isContractQuantityExpired && !isStorageDigContractExpired && isShowWarningExpireDigContract && !isContract1MBQuantityExpired && isShowWarningExpireContract1MBQuantity" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expired' | translate}}
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' | translate}}
                      {{storageDigContractExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <span *ngIf="!isContractQuantityExpired && isShowWarningExpireContractQuantity && isStorageDigContractExpired && !isContract1MBQuantityExpired && isShowWarningExpireContract1MBQuantity" class="font15"
                          style="color: red;">
                      {{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' | translate}}
                      {{ContractQuantityExpireTitle}}.&nbsp;
                      {{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expired' | translate}}
                      {{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' | translate}}
                      {{Contract1MBQuantityExpireTitle}}.&nbsp;
                    </span>
                    <span>{{'analysis.analysis_report_enterprise.notify_contract_expire_end' | translate}}</span>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <!-- Cảnh báo hết hạn hợp đồng -->
      <div class="col-md-12 pr-0 notify-card"
           *ngIf="!((isShowWarningExpireContractQuantity && isShowWarningExpireDigContract)
        || (isShowWarningExpireContractQuantity && isStorageDigContractExpired)
        || (isContractQuantityExpired && isShowWarningExpireDigContract)
        || (isContractQuantityExpired && isStorageDigContractExpired)) 
        && !(((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) && isBuyContract1Mb) 
        && !((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) 
        && isBuyContract1Mb 
        && !isShowWarningExpireContractQuantity 
        && !isShowWarningExpireDigContract))
        && (isShowWarningExpireContractQuantity || isContractQuantityExpired)">
        <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
          <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
            <div class="d-flex">
              <div style="padding-right: 10px;">
                <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-3 pl-2">
                <span *ngIf="isContractQuantityExpired" class="font15"
                      style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_quantity_expired' |
                  translate}}</span>
                <span *ngIf="!isContractQuantityExpired" class="font15"
                      style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_quantity_expire_soon' |
                  translate}}{{ContractQuantityExpireTitle}}.&nbsp;</span>
                <span>{{'analysis.analysis_report_enterprise.notify_contract_expire_end' | translate}}</span>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cảnh báo hết hạn hợp đồng 1MB -->
      <div class="col-md-12 pr-0 notify-card"
          *ngIf="(isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) 
          && isBuyContract1Mb 
          && !isShowWarningExpireContractQuantity 
          && !isShowWarningExpireDigContract">
        <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
          <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
            <div class="d-flex">
              <div style="padding-right: 10px;">
                <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-3 pl-2">
                <span *ngIf="isContract1MBQuantityExpired" class="font15"
                      style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expired' |
                  translate}}</span>
                <span *ngIf="!isContract1MBQuantityExpired" class="font15"
                      style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_1mb_quantity_expire_soon' |
                  translate}}{{Contract1MBQuantityExpireTitle}}.&nbsp;</span>
                <span>{{'analysis.analysis_report_enterprise.notify_contract_expire_end' | translate}}</span>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Cảnh báo hết hạn số hóa hợp đồng -->
      <div class="col-md-12 pr-0 notify-card"
           *ngIf="!((isShowWarningExpireContractQuantity && isShowWarningExpireDigContract)
        || (isShowWarningExpireContractQuantity && isStorageDigContractExpired)
        || (isContractQuantityExpired && isShowWarningExpireDigContract)
        || (isContractQuantityExpired && isStorageDigContractExpired))
        && !(((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) && isBuyContract1Mb) 
        && !((isShowWarningExpireContract1MBQuantity || isContract1MBQuantityExpired) 
        && isBuyContract1Mb 
        && !isShowWarningExpireContractQuantity 
        && !isShowWarningExpireDigContract))
        && (isShowWarningExpireDigContract || isStorageDigContractExpired)">
        <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
          <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
            <div class="d-flex">
              <div style="padding-right: 10px;">
                <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-3 pl-2">
                <span *ngIf="isStorageDigContractExpired" class="font15"
                      style="color: red;">{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expired' |
                  translate}}</span>
                <span *ngIf="!isStorageDigContractExpired" class="font15"
                      style="color: red;">{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire_soon' |
                  translate}}{{storageDigContractExpireTitle}}.&nbsp;</span>
                <span>{{'analysis.analysis_report_enterprise.notify_contract_expire_end' | translate}}</span>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cảnh báo mật khẩu -->
      <div class="col-md-12 pr-0 notify-card" *ngIf="me && me.isWarning">
        <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
          <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
            <div class="d-flex">
              <div style="padding-right: 10px;">
                <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-3 pl-2">
                <span>{{me.messagePasswordExpired}}</span>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--    </div>-->
      <!--    ẩn theo yêu cầu của kinh doanh-->

      <!--    <div class="row" style="padding-right: 0.75rem; justify-content: flex-end">-->
      <!--      &lt;!&ndash; hiện cảnh báo hệ thống&ndash;&gt;-->
      <!--      <div class="col-md-12 pr-0 notify-card">-->
      <!--        <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">-->
      <!--          <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">-->
      <!--            <div class="d-flex">-->
      <!--              <div style="padding-right: 10px;">-->
      <!--                <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>-->
      <!--              </div>-->
      <!--              <div class="flex-grow-3 pl-2">-->
      <!--                <span>{{'cancel_sign_confirm.system_notify_message_key' | translate}}</span>-->
      <!--              </div>-->
      <!--              <div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--    </div>-->

    <div class="container-fluid px-0" *ngIf="isShowByServiceReport || isShowByConsumptionReport">
      <!-- Doanh nghiệp mua dịch vụ -->
      <div id="by-service-report" class="row row-cols-3 g- g-2 gx-2" *ngIf="isShowByServiceReport">
        <!--  Số hợp đồng chưa sử dụng-->
        <div class="col-12 col-md-4 reset-p-col mb-3">
          <div class="card boxshadow-card enterprise-by-service-main">
            <div class="card-body">
              <div class="card-body-content-custom color-9fc63b">
                <div class="d-flex">
                  <div>
                    <div class="card-icon">
                      <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5772_2860)">
                          <path
                            d="M8.08333 16.25H15.6667V18.4167H8.08333V16.25ZM8.08333 11.9167H18.9167V14.0834H8.08333V11.9167ZM8.08333 7.58337H18.9167V9.75004H8.08333V7.58337ZM21.0833 3.25004H16.555C16.1 1.99337 14.9083 1.08337 13.5 1.08337C12.0917 1.08337 10.9 1.99337 10.445 3.25004H5.91667C5.765 3.25004 5.62417 3.26087 5.48333 3.29337C5.06083 3.38004 4.68167 3.59671 4.38917 3.88921C4.19417 4.08421 4.03167 4.32254 3.92333 4.58254C3.815 4.83171 3.75 5.11337 3.75 5.41671V20.5834C3.75 20.8759 3.815 21.1684 3.92333 21.4284C4.03167 21.6884 4.19417 21.9159 4.38917 22.1217C4.68167 22.4142 5.06083 22.6309 5.48333 22.7175C5.62417 22.7392 5.765 22.75 5.91667 22.75H21.0833C22.275 22.75 23.25 21.775 23.25 20.5834V5.41671C23.25 4.22504 22.275 3.25004 21.0833 3.25004ZM13.5 2.97921C13.9442 2.97921 14.3125 3.34754 14.3125 3.79171C14.3125 4.23587 13.9442 4.60421 13.5 4.60421C13.0558 4.60421 12.6875 4.23587 12.6875 3.79171C12.6875 3.34754 13.0558 2.97921 13.5 2.97921ZM21.0833 20.5834H5.91667V5.41671H21.0833V20.5834Z"
                            fill="#2F75D0"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_5772_2860">
                            <rect width="26" height="26" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div class="content-crossbar-bottom">
                    <h4>{{'analysis.analysis_report_enterprise.number_use_contract' | translate}}</h4>
                    <div class=" pb-2">
                      <small *ngIf="!isShowWarningQuanityContract"
                             class="card-body-content-title-three">{{'analysis.analysis_report_enterprise.no_use_contract' |
                        translate}}</small>
                      <small
                        class="txt_show_warning_quanity_contract {{isShowWarningQuanityContract ? '' : 'hide'}}"></small>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="card-body-content-title-secon">
                        <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                        <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.contract_quantity | number}}</span>
                      </span>
                      <div class="contract-icon-quatity {{isShowWarningQuanityContract ? '' : 'hide'}}">
                        <div id="show_warning_quanity_contract" data-original-title="" data-toggle="popover"
                             data-trigger="hover" data-placement="top" data-content="">
                          <div class="ml-3 font12">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
                                fill="#EE0033"/>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

                <!--  Số hợp đồng/văn bản 1MB chưa sử dụng-->
                <div *ngIf="isBuyContract1Mb" class="col-12 col-md-4 reset-p-col mb-3">
                  <div class="card boxshadow-card enterprise-by-service-main">
                    <div class="card-body">
                      <div class="card-body-content-custom color-9fc63b">
                        <div class="d-flex">
                          <div>
                            <div class="card-icon">
                              <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_5772_2860)">
                                  <path
                                    d="M8.08333 16.25H15.6667V18.4167H8.08333V16.25ZM8.08333 11.9167H18.9167V14.0834H8.08333V11.9167ZM8.08333 7.58337H18.9167V9.75004H8.08333V7.58337ZM21.0833 3.25004H16.555C16.1 1.99337 14.9083 1.08337 13.5 1.08337C12.0917 1.08337 10.9 1.99337 10.445 3.25004H5.91667C5.765 3.25004 5.62417 3.26087 5.48333 3.29337C5.06083 3.38004 4.68167 3.59671 4.38917 3.88921C4.19417 4.08421 4.03167 4.32254 3.92333 4.58254C3.815 4.83171 3.75 5.11337 3.75 5.41671V20.5834C3.75 20.8759 3.815 21.1684 3.92333 21.4284C4.03167 21.6884 4.19417 21.9159 4.38917 22.1217C4.68167 22.4142 5.06083 22.6309 5.48333 22.7175C5.62417 22.7392 5.765 22.75 5.91667 22.75H21.0833C22.275 22.75 23.25 21.775 23.25 20.5834V5.41671C23.25 4.22504 22.275 3.25004 21.0833 3.25004ZM13.5 2.97921C13.9442 2.97921 14.3125 3.34754 14.3125 3.79171C14.3125 4.23587 13.9442 4.60421 13.5 4.60421C13.0558 4.60421 12.6875 4.23587 12.6875 3.79171C12.6875 3.34754 13.0558 2.97921 13.5 2.97921ZM21.0833 20.5834H5.91667V5.41671H21.0833V20.5834Z"
                                    fill="#2F75D0"/>
                                </g>
                                <defs>
                                  <clipPath id="clip0_5772_2860">
                                    <rect width="26" height="26" fill="white" transform="translate(0.5)"/>
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </div>
                          <div class="content-crossbar-bottom position-relative">
                            <h4>{{'analysis.analysis_report_enterprise.number_use_contract_1MB' | translate}}</h4>
                            <div class=" pb-2">
                              <small *ngIf="!isShowWarningQuanityContract1MB"
                                     class="card-body-content-title-three">{{'analysis.analysis_report_enterprise.no_use_contract' |
                                translate}}</small>
                              <small
                                class="txt_show_warning_quanity_contract_1mb {{isShowWarningQuanityContract1MB ? '' : 'hide'}}"></small>
                            </div>
                            <div class="d-flex align-items-center">
                              <span class="card-body-content-title-secon">
                                <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                                <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.contract_1mb_quantity | number}}</span>
                              </span>
                              <div class="contract-icon-quatity {{isShowWarningQuanityContract1MB ? '' : 'hide'}}">
                                <div id="show_warning_quanity_contract_1mb" data-original-title="" data-toggle="popover"
                                     data-trigger="hover" data-placement="top" data-content="">
                                  <div class="ml-3 font12">
                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
                                        fill="#EE0033"/>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="position-absolute" style="bottom: 0; right: 0;">
                              <div class="custom-text" nz-popover [(nzVisible)]="visible" [nzPopoverTitle]="titleTemplate" [nzPopoverContent]="contentTemplate" nzPopoverPlacement="bottomRight" nzPopoverTrigger="click">{{'analysis.analysis_report_enterprise.conditions_of_use' | translate}}</div>
                            </div>
                            <ng-template #titleTemplate>
                              <div class="d-flex justify-content-between">
                                <div class="popover-title">{{ 'analysis.analysis_report_enterprise.conditions_for_using_resources' | translate }}</div>
                                <button mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="closePopover()">
                                  <mat-icon style="color: #444444;">close</mat-icon>
                                </button>
                              </div>
                            </ng-template>
                            <ng-template #contentTemplate>
                              <div class="d-flex align-items-center pb-2">
                                <div class="css-dot"></div><span class="css-text">{{ 'analysis.analysis_report_enterprise.total_signing_file_key' | translate }}</span>: <span style="font-size: 16px;" class="ml-1">{{ 'analysis.analysis_report_enterprise.total_signing_file_value' | translate }}</span>
                              </div>
                              <div class="d-flex align-items-center pb-2">
                                <div class="css-dot"></div><span class="css-text">{{ 'analysis.analysis_report_enterprise.quantity_page_signing_file_key' | translate }}</span>: <span style="font-size: 16px;" class="ml-1">{{ 'analysis.analysis_report_enterprise.quantity_page_signing_file_value' | translate }}</span>
                              </div>
                              <div class="d-flex align-items-center pb-2">
                                <div class="css-dot"></div><span class="css-text">{{ 'analysis.analysis_report_enterprise.quantity_signature_setup_key' | translate }}</span>: <span style="font-size: 16px;" class="ml-1">{{ 'analysis.analysis_report_enterprise.quantity_signature_setup_value' | translate }}</span>
                              </div>
                              <div class="d-flex align-items-center pb-2">
                                <div class="css-dot"></div><span class="css-text">{{ 'analysis.analysis_report_enterprise.quantity_approver_key' | translate }}</span>: <span style="font-size: 16px;" class="ml-1">{{ 'analysis.analysis_report_enterprise.quantity_approver_value' | translate }}</span>
                              </div>
                              <div class="d-flex align-items-center justify-content-center">
                                <button mat-stroked-button color="primary" style="min-width: 86px !important;" class="mt-3 mb-1" (click)="closePopover()" type="button">
                                  <mat-icon class="mr-0">cancel</mat-icon>
                                  {{'button.close' | translate}}
                                </button>
                              </div>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

        <!-- Tài khoản tin nhắn -->
        <div *ngIf="isBuySmsBccs" class="col-12 col-md-4 reset-p-col mb-3">
          <div class="card boxshadow-card enterprise-by-service-main">
            <div class="card-body">
              <div class="card-body-content-custom color-9fc63b">
                <div class="d-flex">
                  <div>
                    <div class="card-icon">
                      <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5772_1628)">
                          <path
                            d="M21.8333 4.33337H4.49999C3.30832 4.33337 2.34416 5.30837 2.34416 6.50004L2.33332 19.5C2.33332 20.6917 3.30832 21.6667 4.49999 21.6667H21.8333C23.025 21.6667 24 20.6917 24 19.5V6.50004C24 5.30837 23.025 4.33337 21.8333 4.33337ZM21.8333 19.5H4.49999V8.66671L13.1667 14.0834L21.8333 8.66671V19.5ZM13.1667 11.9167L4.49999 6.50004H21.8333L13.1667 11.9167Z"
                            fill="#2F75D0"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_5772_1628">
                            <rect width="26" height="26" fill="white" transform="translate(0.166656)"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div class="content-crossbar-bottom">
                    <h4 [ngStyle]="{'padding-right.px': isShowWarningQuanityMoney ? 30 : 0}" *ngIf="!isNotAttestedUser">
                      {{'analysis.analysis_report_enterprise.number_use_money_sms' | translate}}
                    </h4>
                    <h4 [ngStyle]="{'padding-right.px': isShowWarningQuanityMoney ? 30 : 0}" *ngIf="isNotAttestedUser">
                      {{'analysis.analysis_report_enterprise.number_use_money_sms_not_attested' | translate}}
                    </h4>
                    <div class="pb-2">
                      <small *ngIf="!isShowWarningQuanityMoney"
                             class="card-body-content-title-three">{{'analysis.analysis_report_enterprise.no_use_money' |
                        translate}}</small>
                      <small class="txt_show_warning_quanity_money {{isShowWarningQuanityMoney ? '' : 'hide'}}"></small>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="card-body-content-title-secon">
                        <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                        <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.money_quantity | number}}{{'analysis.analysis_report_enterprise.unit_use_money' | translate}}</span>
                      </span>
                      <div class="contract-icon-quatity {{isShowWarningQuanityMoney ? '' : 'hide'}}">
                        <div id="show_warning_quanity_money" data-original-title="" data-toggle="popover"
                             data-trigger="hover"
                             data-placement="top" data-content="">
                          <span class="ml-3 font12">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
                                  fill="#EE0033"/>
                                </svg>

                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="isTransferSmsToTsa"
                  class="content-icon-main sms-icon-quatity">
                  <div data-original-title="" data-toggle="popover" data-trigger="hover" data-placement="top"
                       data-content="" style="cursor: pointer;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                         (click)="openDialogRefuseSignDocument(enterpriseByService.money_quantity , 'sms', warningRemittanceSMS)"
                    >
                      <g clip-path="url(#clip0_4386_5058)">
                        <rect width="24.0077" height="24" fill="white"/>
                        <path
                          d="M15.6038 13.8729C15.6161 14.2212 15.548 14.5677 15.405 14.8855C15.2619 15.2034 15.0477 15.4841 14.7788 15.7059C14.1116 16.2116 13.3054 16.5009 12.4688 16.5349V18.0049H11.4868V16.5629C10.4327 16.5628 9.38915 16.353 8.41684 15.9459V14.0529C8.89824 14.2822 9.40055 14.4647 9.91684 14.5979C10.4289 14.743 10.9542 14.8368 11.4848 14.8779V12.6539L11.0038 12.4679C10.2514 12.2165 9.5642 11.8012 8.99184 11.2519C8.59497 10.8055 8.3845 10.2239 8.40384 9.62688C8.39791 9.2983 8.46835 8.97282 8.6096 8.67609C8.75085 8.37935 8.95907 8.11946 9.21784 7.91688C9.87729 7.42718 10.6674 7.14454 11.4878 7.10488V6.00488H12.4698V7.07388C13.4926 7.10494 14.5002 7.32886 15.4398 7.73388L14.7658 9.41188C14.0322 9.10915 13.2566 8.92063 12.4658 8.85288V10.9689C13.1588 11.2127 13.8257 11.5249 14.4568 11.9009C14.8079 12.1208 15.1044 12.4176 15.3238 12.7689C15.5149 13.1049 15.6117 13.4864 15.6038 13.8729ZM10.5618 9.62688C10.5589 9.7242 10.5769 9.82102 10.6147 9.91075C10.6525 10.0005 10.7091 10.081 10.7808 10.1469C10.9924 10.3239 11.2312 10.4658 11.4878 10.5669V8.88088C10.8712 8.97155 10.5625 9.22022 10.5618 9.62688ZM13.4458 13.9809C13.4463 13.8831 13.4246 13.7865 13.3824 13.6983C13.3401 13.6102 13.2784 13.5327 13.2018 13.4719C12.9783 13.2961 12.7321 13.1511 12.4698 13.0409V14.8269C13.1198 14.7169 13.4452 14.4349 13.4458 13.9809Z"
                          fill="#727274"/>
                        <path d="M5.34984 7.92906L6.93584 2.23706L1.13884 2.96606" stroke="#727274" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path
                          d="M11.7928 23.0001C9.34699 22.954 6.98628 22.0939 5.08398 20.5559C3.18169 19.0178 1.84637 16.8895 1.28916 14.5076C0.731954 12.1256 0.984656 9.62581 2.00731 7.40353C3.02997 5.18126 4.76422 3.36328 6.93585 2.23706"
                          stroke="#727274" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.6579 16.071L17.0719 21.763L22.8689 21.034" stroke="#727274" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path
                          d="M12.2148 1C14.6607 1.04607 17.0214 1.90613 18.9237 3.44418C20.826 4.98224 22.1613 7.11052 22.7185 9.49251C23.2757 11.8745 23.023 14.3743 22.0004 16.5965C20.9777 18.8188 19.2435 20.6368 17.0718 21.763"
                          stroke="#727274" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_4386_5058">
                          <rect width="24.0077" height="24" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tài khoản chứng thực -->
        <div *ngIf="isBuyTsaSmsBccs" class="col-12 col-md-4 reset-p-col mb-3">
          <div class=" card boxshadow-card enterprise-by-service-main">
            <div class="card-body">
              <div class="card-body-content-custom color-9fc63b">
                <div class="d-flex">
                  <div>
                    <div class="card-icon">
                      <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5772_1402)">
                          <path
                            d="M23.0834 7.88667V5.41667C23.0834 4.225 22.1084 3.25 20.9167 3.25H5.75004C4.54754 3.25 3.58337 4.225 3.58337 5.41667V20.5833C3.58337 21.775 4.54754 22.75 5.75004 22.75H20.9167C22.1084 22.75 23.0834 21.775 23.0834 20.5833V18.1133C23.7225 17.7342 24.1667 17.0517 24.1667 16.25V9.75C24.1667 8.94833 23.7225 8.26583 23.0834 7.88667ZM22 9.75V16.25H14.4167V9.75H22ZM5.75004 20.5833V5.41667H20.9167V7.58333H14.4167C13.225 7.58333 12.25 8.55833 12.25 9.75V16.25C12.25 17.4417 13.225 18.4167 14.4167 18.4167H20.9167V20.5833H5.75004Z"
                            fill="#2F75D0"/>
                          <path
                            d="M17.6667 14.625C18.5642 14.625 19.2917 13.8975 19.2917 13C19.2917 12.1025 18.5642 11.375 17.6667 11.375C16.7693 11.375 16.0417 12.1025 16.0417 13C16.0417 13.8975 16.7693 14.625 17.6667 14.625Z"
                            fill="#2F75D0"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_5772_1402">
                            <rect width="26" height="26" fill="white" transform="translate(0.333374)"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div class="content-crossbar-bottom">
                    <h4 [ngStyle]="{'padding-right.px': isShowWarningQuanityTsaMoney ? 30 : 0}"
                        *ngIf="!isNotAttestedUser">
                      {{'analysis.analysis_report_enterprise.number_use_money_email' | translate}}</h4>
                    <h4 [ngStyle]="{'padding-right.px': isShowWarningQuanityTsaMoney ? 30 : 0}"
                        *ngIf="isNotAttestedUser">
                      {{'analysis.analysis_report_enterprise.number_use_money_email_not_attested' | translate}}</h4>
                    <div class="pb-2">
                      <small *ngIf="!isShowWarningQuanityTsaMoney"
                             class="card-body-content-title-three">{{'analysis.analysis_report_enterprise.no_use_money' |
                        translate}}</small>
                      <small
                        class="txt_show_warning_quanity_tsa_money {{isShowWarningQuanityTsaMoney ? '' : 'hide'}}"></small>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="card-body-content-title-secon">
                        <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                        <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.tsa_money_quantity | number}}{{'analysis.analysis_report_enterprise.unit_use_money' | translate}}</span>
                      </span>

                      <div class="contract-icon-quatity {{isShowWarningQuanityTsaMoney ? '' : 'hide'}}">
                        <div id="show_warning_quanity_tsa_money" data-original-title="" data-toggle="popover"
                             data-trigger="hover"
                             data-placement="top" data-content="">
                          <span class="ml-3 font12">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
<path
  d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
  fill="#EE0033"/>
</svg>

                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="isTransferTsaToSms"
                  class="content-icon-main sms-icon-quatity">
                  <div data-original-title="" data-toggle="popover" data-trigger="hover" data-placement="top"
                       data-content="" style="cursor: pointer;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                         (click)="openDialogRefuseSignDocument(enterpriseByService.tsa_money_quantity , 'account', warningRemittanceTSA)"
                    >
                      <g clip-path="url(#clip0_4386_5058)">
                        <rect width="24.0077" height="24" fill="white"/>
                        <path
                          d="M15.6038 13.8729C15.6161 14.2212 15.548 14.5677 15.405 14.8855C15.2619 15.2034 15.0477 15.4841 14.7788 15.7059C14.1116 16.2116 13.3054 16.5009 12.4688 16.5349V18.0049H11.4868V16.5629C10.4327 16.5628 9.38915 16.353 8.41684 15.9459V14.0529C8.89824 14.2822 9.40055 14.4647 9.91684 14.5979C10.4289 14.743 10.9542 14.8368 11.4848 14.8779V12.6539L11.0038 12.4679C10.2514 12.2165 9.5642 11.8012 8.99184 11.2519C8.59497 10.8055 8.3845 10.2239 8.40384 9.62688C8.39791 9.2983 8.46835 8.97282 8.6096 8.67609C8.75085 8.37935 8.95907 8.11946 9.21784 7.91688C9.87729 7.42718 10.6674 7.14454 11.4878 7.10488V6.00488H12.4698V7.07388C13.4926 7.10494 14.5002 7.32886 15.4398 7.73388L14.7658 9.41188C14.0322 9.10915 13.2566 8.92063 12.4658 8.85288V10.9689C13.1588 11.2127 13.8257 11.5249 14.4568 11.9009C14.8079 12.1208 15.1044 12.4176 15.3238 12.7689C15.5149 13.1049 15.6117 13.4864 15.6038 13.8729ZM10.5618 9.62688C10.5589 9.7242 10.5769 9.82102 10.6147 9.91075C10.6525 10.0005 10.7091 10.081 10.7808 10.1469C10.9924 10.3239 11.2312 10.4658 11.4878 10.5669V8.88088C10.8712 8.97155 10.5625 9.22022 10.5618 9.62688ZM13.4458 13.9809C13.4463 13.8831 13.4246 13.7865 13.3824 13.6983C13.3401 13.6102 13.2784 13.5327 13.2018 13.4719C12.9783 13.2961 12.7321 13.1511 12.4698 13.0409V14.8269C13.1198 14.7169 13.4452 14.4349 13.4458 13.9809Z"
                          fill="#727274"/>
                        <path d="M5.34984 7.92906L6.93584 2.23706L1.13884 2.96606" stroke="#727274" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path
                          d="M11.7928 23.0001C9.34699 22.954 6.98628 22.0939 5.08398 20.5559C3.18169 19.0178 1.84637 16.8895 1.28916 14.5076C0.731954 12.1256 0.984656 9.62581 2.00731 7.40353C3.02997 5.18126 4.76422 3.36328 6.93585 2.23706"
                          stroke="#727274" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.6579 16.071L17.0719 21.763L22.8689 21.034" stroke="#727274" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"/>
                        <path
                          d="M12.2148 1C14.6607 1.04607 17.0214 1.90613 18.9237 3.44418C20.826 4.98224 22.1613 7.11052 22.7185 9.49251C23.2757 11.8745 23.023 14.3743 22.0004 16.5965C20.9777 18.8188 19.2435 20.6368 17.0718 21.763"
                          stroke="#727274" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_4386_5058">
                          <rect width="24.0077" height="24" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Số lượng ekyc -->
        <div *ngIf="isBoughtEkyc" class="col-12 col-md-4 reset-p-col mb-3">
          <div class=" enterprise-by-service-main">
            <div class="card border-radius-20">
              <div class="card-body flex-custom">
                <div class="card-body-content-custom color-9fc63b height-100-percent">
                  <div class="d-flex">
                    <div>
                      <div class="card-icon">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_5772_944)">
                            <path
                              d="M9.75 17.5175L5.99083 13.7583C5.56833 13.3358 4.88583 13.3358 4.46333 13.7583C4.04083 14.1808 4.04083 14.8633 4.46333 15.2858L8.99166 19.8142C9.41416 20.2367 10.0967 20.2367 10.5192 19.8142L21.9808 8.35249C22.4033 7.92999 22.4033 7.24749 21.9808 6.82499C21.5583 6.40249 20.8758 6.40249 20.4533 6.82499L9.75 17.5175Z"
                              fill="#2F75D0"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_5772_944">
                              <rect width="26" height="26" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div class="content-crossbar-bottom height-100-percent">
                      <div class="title-icon">
                        <h4 class="cart-title-ekyc">
                          {{'analysis.analysis_report_enterprise.number_use_ekyc' | translate}}
                        </h4>
                      </div>
                      <div class="wrap-warning-ekyc pb-2">
                        <small *ngIf="!isShowWarningQuanityEkyc"
                               class="card-body-content-title-three font-size-12">{{'analysis.analysis_report_enterprise.no_use_ekyc'
                          |
                          translate}}</small>
                        <small
                          class="txt_show_warning_quanity_ekyc font-size-12 {{isShowWarningQuanityEkyc ? '' : 'hide'}}"></small>
                      </div>
                      <div class="d-flex align-items-center">
                      <span class="card-body-content-title-secon is-red">
                        <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                        <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.ekyc_quantity | number}}</span>
                      </span>
                        <div class="contract-icon-quatity {{isShowWarningQuanityEkyc ? '' : 'hide'}}">
                          <div id="show_warning_quanity_ekyc" data-original-title="" data-toggle="popover"
                               data-trigger="hover" data-placement="top" data-content="">
                        <span class="ml-3 font12">
                          <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
<path
  d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
  fill="#EE0033"/>
</svg>

                        </span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Số lượng ekyc nang cao -->
        <div *ngIf="isBoughtEkycAdvanced" class="col-12 col-md-4 reset-p-col mb-3">
          <div class="enterprise-by-service-main">
            <div class="card border-radius-20">
              <div class="card-body flex-custom">
                <div class="card-body-content-custom color-9fc63b height-100-percent">
                  <div class="d-flex">
                    <div>
                      <div class="card-icon">
                        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M3.04294 3.73965H24.519C25.7002 3.73965 26.6667 4.66569 26.6667 5.7975L26.6559 20.2025C26.6559 21.3343 25.7002 22.2603 24.519 22.2603H3.04294C1.86175 22.2603 0.895325 21.3343 0.895325 20.2025V5.7975C0.895325 4.66569 1.86175 3.73965 3.04294 3.73965ZM12.7072 9.9132C12.7072 8.20519 11.2683 6.82643 9.48577 6.82643C7.70325 6.82643 6.26435 8.20519 6.26435 9.9132C6.26435 11.6212 7.70325 13 9.48577 13C11.2683 13 12.7072 11.6212 12.7072 9.9132ZM3.04294 18.1446V19.1735H15.9286V18.1446C15.9286 16.0868 11.6334 14.9549 9.48577 14.9549C7.33816 14.9549 3.04294 16.0868 3.04294 18.1446ZM17.0854 8.97394L19.0118 10.8198L23.9038 6.1366L24.5552 6.76073L19.0118 12.0724L16.4295 9.59807L17.0854 8.97394Z"
                                fill="#2F75D0"/>
                        </svg>
                      </div>
                    </div>
                    <div class="content-crossbar-bottom height-100-percent">
                      <div class="title-icon">
                        <h4 class="cart-title-ekyc">
                          {{'analysis.analysis_report_enterprise.number_use_ekyc_advanced' | translate}}
                        </h4>
                      </div>
                      <div class="wrap-warning-ekyc pb-2">
                        <small *ngIf="!isShowWarningQuanityEkycAdvanced"
                               class="card-body-content-title-three font-size-12">{{'analysis.analysis_report_enterprise.no_use_ekyc_advanced'
                          |
                          translate}}</small>
                        <small
                          class="txt_show_warning_quanity_ekyc font-size-12 {{isShowWarningQuanityEkycAdvanced ? '' : 'hide'}}"></small>
                      </div>
                      <div class="d-flex align-items-center">
                      <span class="card-body-content-title-secon is-blue">
                        <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                        <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.ekyc_advanced_quantity | number}}</span>
                      </span>
                        <div class="contract-icon-quatity {{isShowWarningQuanityEkycAdvanced ? '' : 'hide'}}">
                          <div id="show_warning_quanity_ekyc_advanced" data-original-title="" data-toggle="popover"
                               data-trigger="hover" data-placement="top" data-content="">
                        <span class="ml-3 font12">
                   <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path
  d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
  fill="#EE0033"/>
</svg>

                        </span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Dung lượng số hóa -->
        <div *ngIf="isStorageDigitalContract" class="col-12 col-md-4 reset-p-col mb-3">
          <div class="enterprise-by-service-main">
            <div class="card border-radius-20">
              <div class="card-body">
                <div class="card-body-content-custom color-9fc63b">
                  <div class="d-flex">
                    <div>
                      <div class="card-icon">
                        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_5772_728)">
                            <path
                              d="M21.2959 10.8767C20.5592 7.13918 17.2767 4.33334 13.3334 4.33334C10.2025 4.33334 7.48337 6.11001 6.12921 8.71001C2.86837 9.05668 0.333374 11.8192 0.333374 15.1667C0.333374 18.7525 3.24754 21.6667 6.83337 21.6667H20.9167C23.9067 21.6667 26.3334 19.24 26.3334 16.25C26.3334 13.39 24.1125 11.0717 21.2959 10.8767ZM20.9167 19.5H6.83337C4.43921 19.5 2.50004 17.5608 2.50004 15.1667C2.50004 12.7725 4.43921 10.8333 6.83337 10.8333H7.60254C8.31754 8.33084 10.6034 6.50001 13.3334 6.50001C16.6267 6.50001 19.2917 9.16501 19.2917 12.4583V13H20.9167C22.715 13 24.1667 14.4517 24.1667 16.25C24.1667 18.0483 22.715 19.5 20.9167 19.5Z"
                              fill="#2F75D0"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_5772_728">
                              <rect width="26" height="26" fill="white" transform="translate(0.333374)"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div class="content-crossbar-bottom">
                      <h4>{{'analysis.analysis_report_enterprise.number_use_storage_dig_contract' | translate}}</h4>
                      <div class="pb-2">
                        <small *ngIf="!isShowWarningStorageDigitalContract"
                               class="card-body-content-title-three">{{'analysis.analysis_report_enterprise.no_use_storage_dig_contract'
                          |
                          translate}} </small>
                        <small
                          class="txt_show_warning_storage_digital_contract {{isShowWarningStorageDigitalContract ? '' : 'hide'}}"></small>
                      </div>
                      <div class="d-flex align-items-center">
                      <span class="card-body-content-title-secon">
                        <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                        <span *ngIf="!loadingEnterpriseService">{{isShowRounding ? '~' : ''}}{{storageDigitalContractValue}}{{unitStorageDigitalContract}}</span>
                      </span>
                        <div class="contract-icon-quatity {{isShowWarningStorageDigitalContract ? '' : 'hide'}}">
                          <div id="show_warning_storage_digital_contract" data-original-title="" data-toggle="popover"
                               data-trigger="hover" data-placement="top" data-content="">
                        <span class="ml-3 font12">
                      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path
  d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
  fill="#EE0033"/>
</svg>

                        </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Dung lượng tải tệp > 10MB -->
        <div *ngIf="isStorageBiggerThan10MBFileSize" class="col-12 col-md-4 reset-p-col mb-3">
          <div class="enterprise-by-service-main">
            <div class="card border-radius-20">
              <div class="card-body">
                <div class="card-body-content-custom color-9fc63b">
                  <div class="d-flex">
                    <div>
                      <div class="card-icon">
                        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_5772_728)">
                            <path
                              d="M21.2959 10.8767C20.5592 7.13918 17.2767 4.33334 13.3334 4.33334C10.2025 4.33334 7.48337 6.11001 6.12921 8.71001C2.86837 9.05668 0.333374 11.8192 0.333374 15.1667C0.333374 18.7525 3.24754 21.6667 6.83337 21.6667H20.9167C23.9067 21.6667 26.3334 19.24 26.3334 16.25C26.3334 13.39 24.1125 11.0717 21.2959 10.8767ZM20.9167 19.5H6.83337C4.43921 19.5 2.50004 17.5608 2.50004 15.1667C2.50004 12.7725 4.43921 10.8333 6.83337 10.8333H7.60254C8.31754 8.33084 10.6034 6.50001 13.3334 6.50001C16.6267 6.50001 19.2917 9.16501 19.2917 12.4583V13H20.9167C22.715 13 24.1667 14.4517 24.1667 16.25C24.1667 18.0483 22.715 19.5 20.9167 19.5Z"
                              fill="#2F75D0"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_5772_728">
                              <rect width="26" height="26" fill="white" transform="translate(0.333374)"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div class="content-crossbar-bottom">
                      <h4>{{'analysis.analysis_report_enterprise.file_download_capacity' | translate}}</h4>
                      <div class="pb-2">
                        <small *ngIf="!isShowWarningStorageThan10MBFileSize"
                               class="card-body-content-title-three">{{'analysis.analysis_report_enterprise.no_use_storage_dig_contract' | translate}} </small>
                        <small *ngIf="isShowWarningStorageThan10MBFileSize && biggerThan10MBFileSize == 0"
                               class="txt_show_warning_storage_digital_contract">{{'analysis.analysis_report_enterprise.the_number_of_storage_than10MB_has_expired' | translate}} </small>
                        <small *ngIf="isShowWarningStorageThan10MBFileSize && biggerThan10MBFileSize > 0"
                               class="txt_show_warning_storage_digital_contract">{{'analysis.analysis_report_enterprise.the_number_of_storage_than10MB_used_up_soon' | translate}} </small>
                      </div>
                      <div class="d-flex align-items-center">
                        <span class="card-body-content-title-secon">
                          <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                          <span *ngIf="!loadingEnterpriseService">{{storageThan10MBValue}}{{unitStorageThan10MB}}</span>
                        </span>
                          <div class="contract-icon-quatity {{isShowWarningStorageThan10MBFileSize ? '' : 'hide'}}">
                            <div id="show_warning_storage_than10MB" data-original-title="" data-toggle="popover"
                                data-trigger="hover" data-placement="top" [attr.data-content]="messageNotify">
                              <span class="ml-3 font12">
                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M12.1667 2C6.64666 2 2.16666 6.48 2.16666 12C2.16666 17.52 6.64666 22 12.1667 22C17.6867 22 22.1667 17.52 22.1667 12C22.1667 6.48 17.6867 2 12.1667 2ZM13.1667 17H11.1667V15H13.1667V17ZM13.1667 13H11.1667V7H13.1667V13Z"
                                  fill="#EE0033"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tài nguyên chứng thực Tindy -->
        <div *ngIf="isBoughtTindy" class="col-12 col-md-4 reset-p-col mb-3">
          <div class="card boxshadow-card enterprise-by-service-main">
            <div class="card-body">
              <div class="card-body-content-custom color-9fc63b">
                <div class="d-flex">
                  <div>
                    <div class="card-icon">
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.0673 9H4.33333C2.49238 9 1 7.50762 1 5.66667C1 3.82572 2.49238 2.33333 4.33333 2.33333H17.0673M8.93266 23.6667H21.6667C23.5076 23.6667 25 22.1743 25 20.3333C25 18.4924 23.5076 17 21.6667 17H8.93266M1 20.3333C1 22.9107 3.08934 25 5.66667 25C8.244 25 10.3333 22.9107 10.3333 20.3333C10.3333 17.756 8.244 15.6667 5.66667 15.6667C3.08934 15.6667 1 17.756 1 20.3333ZM25 5.66667C25 8.244 22.9107 10.3333 20.3333 10.3333C17.756 10.3333 15.6667 8.244 15.6667 5.66667C15.6667 3.08934 17.756 1 20.3333 1C22.9107 1 25 3.08934 25 5.66667Z" stroke="#2F75D0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                  <div class="content-crossbar-bottom">
                    <h4>{{'analysis.analysis_report_enterprise.number_use_tindy' | translate}}</h4>
                    <span class="card-body-content-title-secon">
                      <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                      <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.tindy_quantity | number}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tài nguyên dấu thời gian Mytime -->
        <div *ngIf="isBoughtMytime" class="col-12 col-md-4 reset-p-col mb-3">
          <div class="card boxshadow-card enterprise-by-service-main">
            <div class="card-body">
              <div class="card-body-content-custom color-9fc63b">
                <div class="d-flex">
                  <div>
                    <div class="card-icon">
                      <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25 8.33333V5.26667C25 3.7732 25 3.02646 24.7093 2.45603C24.4537 1.95426 24.0457 1.54631 23.544 1.29065C22.9735 1 22.2268 1 20.7333 1H5.26667C3.77319 1 3.02646 1 2.45603 1.29065C1.95426 1.54631 1.54631 1.95426 1.29065 2.45603C1 3.02646 1 3.77319 1 5.26667V18.0667C1 19.5601 1 20.3069 1.29065 20.8773C1.54631 21.3791 1.95426 21.787 2.45603 22.0427C3.02646 22.3333 3.77319 22.3333 5.26667 22.3333L20.7333 22.3333C22.2268 22.3333 22.9735 22.3333 23.544 22.0427C24.0457 21.787 24.4537 21.3791 24.7093 20.8773C25 20.3069 25 19.5601 25 18.0667V15M18.3333 11.6667C18.3333 11.0471 18.3333 10.7374 18.3846 10.4798C18.595 9.42192 19.4219 8.59499 20.4798 8.38457C20.7374 8.33333 21.0471 8.33333 21.6667 8.33333H24.3333C24.9529 8.33333 25.2626 8.33333 25.5202 8.38457C26.5781 8.59499 27.405 9.42192 27.6154 10.4798C27.6667 10.7374 27.6667 11.0471 27.6667 11.6667C27.6667 12.2862 27.6667 12.596 27.6154 12.8536C27.405 13.9114 26.5781 14.7383 25.5202 14.9488C25.2626 15 24.9529 15 24.3333 15H21.6667C21.0471 15 20.7374 15 20.4798 14.9488C19.4219 14.7383 18.595 13.9114 18.3846 12.8536C18.3333 12.596 18.3333 12.2862 18.3333 11.6667Z" stroke="#2F75D0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                  <div class="content-crossbar-bottom">
                    <h4>{{'analysis.analysis_report_enterprise.number_use_mytime' | translate}}</h4>
                    <span class="card-body-content-title-secon">
                      <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                      <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.mytime_quantity | number}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tài nguyên chữ ký số Mysign -->
        <div *ngIf="isBoughtMysign" class="col-12 col-md-4 reset-p-col mb-3">
          <div class="card boxshadow-card enterprise-by-service-main">
            <div class="card-body">
              <div class="card-body-content-custom color-9fc63b">
                <div class="d-flex">
                  <div>
                    <div class="card-icon">
                      <svg width="29" height="25" viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.5479 5.93213C26.8721 6.75868 27.7588 8.228 27.7588 9.90576V18.9497C27.7585 21.5337 25.6583 23.6343 23.0742 23.6343H5.35254C2.76846 23.6343 0.667255 21.5337 0.666992 18.9497V9.90576C0.666992 7.32152 2.76829 5.22021 5.35254 5.22021H21.4492L21.0352 6.15674L19.0225 10.7095C18.6973 11.4433 19.031 12.3067 19.7656 12.6313H19.7646C19.9539 12.7146 20.1517 12.7554 20.3555 12.7554C20.9324 12.7554 21.4563 12.4142 21.6904 11.8862L24.2715 6.04541L25.5479 3.15771V5.93213ZM9.12988 11.6763C8.15465 11.6763 7.34136 12.0088 6.6377 12.6929C6.16016 13.1691 5.86156 13.6908 5.71387 14.27V14.271C5.69911 14.3285 5.71117 14.3887 5.75586 14.4438C5.80221 14.501 5.87143 14.5356 5.94727 14.5356C6.08921 14.5356 6.17473 14.4442 6.19141 14.3765L6.19238 14.3755C6.32528 13.8399 6.59187 13.3735 6.9834 12.9819C7.55533 12.4102 8.28447 12.1138 9.12695 12.1138C9.86664 12.1138 10.5124 12.3417 11.0547 12.7739L11.2803 12.9722L11.291 12.9819L11.3008 12.9917C11.6737 13.3805 11.931 13.8419 12.0615 14.3706H12.0625L12.0811 14.4146L12.1289 14.5044L12.1475 14.605C12.2998 15.1514 12.5905 15.6448 13.0449 16.1011C13.7476 16.7865 14.5806 17.1235 15.5615 17.1235C16.539 17.1234 17.3528 16.7885 18.0576 16.1011C18.532 15.6264 18.8293 15.1078 18.9766 14.5308L18.9775 14.5288C18.9922 14.4713 18.9802 14.411 18.9355 14.356C18.8893 14.2989 18.8199 14.2643 18.7441 14.2642C18.6022 14.2642 18.5158 14.3555 18.499 14.4233V14.4243C18.3661 14.9599 18.0995 15.4264 17.708 15.8179C17.1361 16.3897 16.407 16.686 15.5645 16.686C14.7192 16.686 13.996 16.3887 13.4102 15.8286L13.4004 15.8179L13.3906 15.8081C13.0175 15.4192 12.7594 14.958 12.6289 14.4292L12.6094 14.3853L12.5625 14.2954L12.5439 14.1958H12.543C12.3907 13.649 12.1004 13.1554 11.6455 12.6987L11.5127 12.5747C10.8386 11.9727 10.0496 11.6763 9.12988 11.6763Z" stroke="#2F75D0" stroke-width="1.33333" stroke-miterlimit="10"/>
                      </svg>
                    </div>
                  </div>
                  <div class="content-crossbar-bottom">
                    <h4>{{'analysis.analysis_report_enterprise.number_use_mysign' | translate}}</h4>
                    <span class="card-body-content-title-secon">
                      <span *ngIf="loadingEnterpriseService" class="skeleton-chip"></span>
                      <span *ngIf="!loadingEnterpriseService">{{enterpriseByService.mysign_quantity | number}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Tạo hợp đồng ngay -->
    <h6 class="row"
        *ngIf="!isShowByServiceReport && mediaBreakpoint !== SCREEN_SIZE.XS && mediaBreakpoint !== SCREEN_SIZE.SM && checkPermissionCreateContract()"
        style="padding-left: 1em; padding-right: 1em;">
      <div class="drd-container col-12">
        <!-- <input style="cursor: pointer;" type="file" #inputUpload id="file" accept="application/pdf"
            class="form-control-file vt-input-form d-none" name="file" (change)="onSelectedUpload($event)" /> -->
        <br/>
        <h3 style="color: #005E5B;">{{'enterprise_contract.panel_document.lb_create_document'| translate}}</h3>
        <br/>
        <button #btnUpload id="btnUpload" mat-stroked-button class="mr-2" color="primary" type="button"
                (click)="onBtnUploadClick()" [ngClass]="{'active_document' : false}">
          <mat-icon class="mr-0">cloud_upload</mat-icon>
          {{'button.choose_a_file' | translate}}
        </button>
        {{'enterprise_contract.panel_document.lb_or'| translate}}
        <button #btnForm mat-stroked-button class="ml-2" color="primary" type="button" [ngStyle]="{'color': null}"
                [ngClass]=" {'active_document' : false}" (click)="onSelectedFormClick()">
          <mat-icon class="mr-0">book</mat-icon>
          {{'button.document_form' | translate}}
        </button>
        <h5 style="margin-top:2em;">({{mesage}})</h5>
        <br/><br/>
      </div>
    </h6>

    <!--    <div class="">-->
    <div class="row">
      <!-- Thống kê hợp đồng người dùng lập -->
      <div id="user-report" class="col-md-6 col-sm-12 pr-0" *ngIf="isShowUserReport">
        <div class="card boxshadow-card">
          <div class="card-header font-weight-bold text-primary font16">
            {{'analysis.title.my_created' | translate}}
          </div>
          <div class="card-body">
            <ng-container *ngIf="!loadingUserStat && chartOptionsUser; else chartSkeleton">
              <highcharts-chart id="userColumnChart" [Highcharts]="highcharts" [options]="chartOptionsUser"
                                style="width: 100%; height: auto; display: block;">
              </highcharts-chart>
            </ng-container>
          </div>
        </div>
      </div>
      <!--Hợp đồng chờ người dùng xử lý-->
      <div id="user-handle" class="col-md-6 col-sm-12" style="padding-right: 0.75rem; padding-bottom: 0.75rem;">
        <div class="card boxshadow-card">
          <div class="card-header font-weight-bold text-primary font16">
            {{'analysis.title.waiting_mine' | translate}}
          </div>
          <div class="card-body">
            <ng-container *ngIf="!loadingUserStat && chartOptionsUserHandle; else chartSkeleton">
              <highcharts-chart id="chartOptionsUserHandle" [Highcharts]="highcharts" [options]="chartOptionsUserHandle"
                                style="width: 100%; height: auto; display: block;">
              </highcharts-chart>
            </ng-container>
          </div>
        </div>
      </div>

      <ng-container *ngIf="isShowByConsumptionReport || isShowEnterpriseReport || isShowPartnerReport">
        <div class="col-12 reset-p-col">
          <div class="bg-white p-3">
            <!--  form search date  -->
            <div class="d-flex justify-content-between align-items-center displayTime">
              <div class="title-time">{{'analysis.title.time_to_use' | translate}}</div>
              <div class="d-flex">
                <!--  CBB  -->
                <div>
                  <!-- ngày/tuần/tháng -->
                  <mat-form-field class="mr-2 border-none p-none" style="width: 70px; font-size: 16px; border: none;">
                    <mat-select id="op" name="op" [(ngModel)]="optionsSelect"
                                (selectionChange)="onChangeSelect($event.value)">
                      <mat-option [value]="1">{{'analysis.analysis_report_consumption.options.day' | translate}}
                      </mat-option>
                      <mat-option [value]="2">{{'analysis.analysis_report_consumption.options.week' | translate}}
                      </mat-option>
                      <mat-option [value]="3">{{'analysis.analysis_report_consumption.options.month' | translate}}
                      </mat-option>
                      <mat-option [value]="4">{{'analysis.analysis_report_consumption.options.quarter' | translate}}
                      </mat-option>
                      <mat-option [value]="5">{{'analysis.analysis_report_consumption.options.year' | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!--  date picker  -->
                <div>
                  <div class="d-flex flex-wrap align-items-baseline" [formGroup]="consumptionFormGroup">
                    <!-- Từ ngày -->
                    <span class="mr-1" style="font-size: 16px;">
                  {{'analysis.analysis_report_consumption.options.from_date' | translate}}:</span>
                    <mat-form-field class="mat-select-consumption mr-3 border-none width-time" style="width: 120px;">
                      <input #inputFromDate matInput [matDatepicker]="createdTimeFromReference"
                             formControlName="fromDate"
                             (dateChange)="changeDatePickerFromDate('change', $event)"
                             (keyup.enter)="keyupEnterSelected();"
                             autocomplete="off" maxlength="200" #pickerInputFromDate/>
                      <mat-datepicker-toggle matSuffix [for]="createdTimeFromReference">
                        <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                           [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                      </mat-datepicker-toggle>
                      <mat-datepicker #createdTimeFromReference></mat-datepicker>
                      <!-- error -->
                      <mat-error
                        *ngIf="consumptionFormGroup.get('fromDate').invalid && (consumptionFormGroup.get('fromDate').dirty || consumptionFormGroup.get('fromDate').touched)"
                        style="font-size: 12px !important;">
                    <span *ngIf="consumptionFormGroup.get('fromDate').invalid">
                      {{getErrorDateMessageRange(pickerInputFromDate.value)}}
                    </span>
                        <span *ngIf="getErrorDateMessageRange(pickerInputFromDate.value)==null">
                      {{'validation.empty_of_date_consumption' | translate}}
                    </span>
                      </mat-error>

                      <!-- <mat-error
                          *ngIf="consumptionFormGroup.get('fromDate').invalid && (consumptionFormGroup.get('fromDate').dirty || consumptionFormGroup.get('fromDate').touched)"
                          style="font-size: 12px !important;">
                          <span *ngIf="consumptionFormGroup.get('fromDate').hasError('required')">
                            {{'validation.empty_of_date_consumptions' | translate}}<br />
                          </span>
                          <span *ngIf="consumptionFormGroup.get('fromDate').hasError('dateInValid')">
                            {{'validation.format_of_date_consumption' | translate}}
                          </span>
                          <span *ngIf="consumptionFormGroup.get('fromDate')?.errors?.required">
                            {{'validation.empty_of_date_consumption' | translate}}
                          </span>
                          <span
                            *ngIf="consumptionFormGroup.get('fromDate')?.value && formGroup.get('fromDate')?.errors?.isValid">
                          {{'validation.format_of_date_consumption' | translate}}
                          </span>
                        </mat-error> -->

                      <!-- <mat-error style="font-size: 12px !important;">{{inValideFormDateEmpty}}</mat-error>
                        <mat-error style="font-size: 12px !important;">{{inValidFromDateFormat}}</mat-error> -->
                      <!-- <mat-error *ngIf="isShowWarningConsumptionFromDate" style="font-size: 12px !important;">
                          <span *ngIf="optionsSelect === 1">{{ 'search_form.limit_day_select_create_date' | translate
                            }}</span>
                          <span *ngIf="optionsSelect === 2">{{ 'search_form.limit_week_select_create_date' | translate
                            }}</span>
                          <span *ngIf="optionsSelect === 3">{{ 'search_form.limit_month_select_create_date' | translate
                            }}</span>
                        </mat-error> -->
                    </mat-form-field>

                    <!-- Đến ngày -->
                    <span class="mr-1" style="font-size: 16px">
                  {{'analysis.analysis_report_consumption.options.to_date' | translate}}:</span>
                    <mat-form-field class="mat-select-consumption border-none" style="width: 120px;">
                      <input #inputToDate matInput [matDatepicker]="createdTimeToReference" formControlName="toDate"
                             (dateChange)="changeDatePickerToDate('change', $event)"
                             (keyup.enter)="keyupEnterSelected();"
                             autocomplete="off" maxlength="200" #pickerInputToDate/>
                      <mat-datepicker-toggle matSuffix [for]="createdTimeToReference">
                        <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                           [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                      </mat-datepicker-toggle>
                      <mat-datepicker #createdTimeToReference></mat-datepicker>
                      <!-- error -->
                      <mat-error
                        *ngIf="consumptionFormGroup.get('toDate').invalid && (consumptionFormGroup.get('toDate').dirty || consumptionFormGroup.get('toDate').touched)"
                        style="font-size: 12px !important;">
                    <span *ngIf="consumptionFormGroup.get('toDate').invalid">
                      {{getErrorDateMessageRange(pickerInputToDate.value)}}
                    </span>
                        <span *ngIf="getErrorDateMessageRange(pickerInputToDate.value)==null">
                      {{'validation.empty_of_date_consumption' | translate}}
                    </span>
                      </mat-error>

                      <!-- <mat-error
                          *ngIf="consumptionFormGroup.get('toDate').invalid && (consumptionFormGroup.get('toDate').dirty || consumptionFormGroup.get('toDate').touched)"
                          style="font-size: 12px !important;">
                          <span *ngIf="consumptionFormGroup.get('toDate').hasError('required')">
                            {{'validation.empty_of_date_consumptions' | translate}}<br />
                          </span>
                          <span *ngIf="consumptionFormGroup.get('toDate').hasError('dateInvalidToDate')">
                            {{'validation.format_of_date_consumption' | translate}}
                          </span>
                          <span *ngIf="consumptionFormGroup.get('toDate')?.errors?.required">
                            {{'validation.empty_of_date_consumption' | translate}}
                          </span>
                          <span
                            *ngIf="consumptionFormGroup.get('toDate')?.value && formGroup.get('toDate')?.errors?.isValid">
                          {{'validation.format_of_date_consumption' | translate}}
                          </span>
                        </mat-error> -->

                      <!-- <mat-error style="font-size: 12px !important;">{{inValideToDateEmpty}}</mat-error>
                        <mat-error style="font-size: 12px !important;">{{inValidToDateFormat}}</mat-error> -->
                      <!-- <mat-error *ngIf="isShowWarningConsumptionToDate" style="font-size: 12px !important;">
                          <span *ngIf="optionsSelect === 1">{{ 'search_form.limit_day_select_create_date' | translate
                            }}</span>
                          <span *ngIf="optionsSelect === 2">{{ 'search_form.limit_week_select_create_date' | translate
                            }}</span>
                          <span *ngIf="optionsSelect === 3">{{ 'search_form.limit_month_select_create_date' | translate
                            }}</span>
                        </mat-error> -->
                    </mat-form-field>
                  </div>

                  <!-- Thông báo lỗi khi chọn thời gian -->
                  <div *ngIf="isShowWarningConsumptionFromDate || isShowWarningConsumptionToDate"
                       style="text-align: right;">
                    <mat-error style="font-size: 12px !important;" [ngSwitch]="optionsSelect">
                  <span *ngSwitchCase="1">{{ 'search_form.limit_day_select_create_date' | translate
                    }}</span>
                      <span *ngSwitchCase="2">{{ 'search_form.limit_week_select_create_date' | translate
                        }}</span>
                      <span *ngSwitchCase="3">{{ 'search_form.limit_month_select_create_date' | translate
                        }}</span>
                      <span *ngSwitchCase="4">{{ 'search_form.limit_quarter_select_create_date' | translate
                        }}</span>
                      <span *ngSwitchCase="5">{{ 'search_form.limit_year_select_create_date' | translate
                        }}</span>
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>

            <!-- Thống kê số SMS, Hợp đồng -->
            <div *ngIf="isShowByConsumptionReport" class="w-100 mb-4">
              <div class="card boxshadow-card">
                <div class="card-header font-weight-bold">
                  <div class="d-flex row">
                    <div class="flex-grow-1 col-6 width-title">
                    <span class="font16"
                          *ngIf="!isNotAttestedUser">{{'analysis.title.consumption' | translate}}</span>
                      <span class="font16"
                            *ngIf="isNotAttestedUser">{{'analysis.title.consumption_not_attested' | translate}}</span>
                    </div>
                  </div>
                </div>

                <!--  Line chart  -->
                <div class="card-body">
                  <ng-container *ngIf="!loadingConsumption && chartOptionsConsumption && color_primary; else chartSkeleton">
                    <highcharts-chart id="consumptionLineChart" [Highcharts]="highcharts"
                                      [options]="chartOptionsConsumption"
                                      style="width: 100%; height: 300px; display: block;">
                    </highcharts-chart>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="isNotAttestedUser; else viewVContract">
              <!-- HĐ Doanh nghiệp lập-->
              <div *ngIf="isShowEnterpriseReport" class="col-md-6-sContract col-md-6  pr-2 mb-4">
                <div class="card boxshadow-card">
                  <div class="card-header font-weight-bold font16">
                    {{'analysis.title.enterprise' | translate}}</div>
                  <div class="card-body">
                    <ng-container *ngIf="showChartEnterprise; else chartNoData">
                      <highcharts-chart id="userPieChart" [Highcharts]="highcharts" [options]="chartOptionsEnterprise"
                                        class="pie-chart-item">
                      </highcharts-chart>
                    </ng-container>
                  </div>
                </div>
              </div>

              <!-- HĐ nhận từ đối tác -->
              <div *ngIf="isShowPartnerReport" id="partner-report" class="col-md-6-sContract col-md-6  "
                   style="padding-right: 0.75rem;">
                <div class="card boxshadow-card partner-main">
                  <div class="card-header font-weight-bold font16">
                    {{'analysis.title.partner' | translate}}</div>
                  <div class="card-body">
                    <div class="row flex-grow-1">

                      <div class="col-6 mb-4"
                           [ngStyle]="{'padding-right': '0.75rem'}">
                        <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.WAIT_SETUP_FLOW)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-ff7840 icon-image">
                                <ng-container *ngTemplateOutlet="iconWait"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div
                                class="card-contract__value cursor-pointer"
                                style="color: #ff7840">{{documentEnterpriseReceive.waitSetSignFlow}}</div>
                              <div
                                class="card-contract__title contractNhan">{{'analysis.analysis_report_partner.status.wait_setup_flow' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-6 mb-4 pr-075">
                        <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.PROCESSING)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-2f75D0 icon-image">
                                <ng-container *ngTemplateOutlet="iconProcess"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div
                                class="card-contract__value cursor-pointer"
                                style="color: #2f75D0">{{documentEnterpriseReceive.processing}}</div>
                              <div
                                class="card-contract__title contractNhan1">{{'analysis.analysis_report_partner.status.processing' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-6 pr-075">
                        <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.SIGNED)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-15b98c icon-image">
                                <ng-container *ngTemplateOutlet="iconResolve"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div
                                class="card-contract__value cursor-pointer"
                                style="color: #15b98c">{{documentEnterpriseReceive.signed}}</div>
                              <div
                                class="card-contract__title contractNhan1">{{'analysis.analysis_report_partner.status.signed' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-6 pr-075">
                        <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.REJECTED)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-ee0033 icon-image">
                                <ng-container *ngTemplateOutlet="iconReject"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div
                                class="card-contract__value cursor-pointer"
                                style="color: #ee0033">{{documentEnterpriseReceive.rejected}}</div>
                              <div
                                class="card-contract__title contractNhan1">{{'analysis.analysis_report_partner.status.refused' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #viewVContract>
        <div class="row">
          <!-- HĐ Doanh nghiệp lập-->
          <div class="col-md-6 col-sm-12 pr-2 mb-4" *ngIf="isShowEnterpriseReport">
            <div class="card boxshadow-card">
              <div class="card-header font-weight-bold font16">
                {{'analysis.title.enterprise' | translate}}</div>
              <div class="card-body">
                <ng-container *ngIf="showChartEnterprise; else chartNoData">
                  <highcharts-chart id="userPieChart" [Highcharts]="highcharts" [options]="chartOptionsEnterprise"
                                    class="pie-chart-item">
                  </highcharts-chart>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- HĐ Doanh nghiệp BCT-->
          <div *ngIf="isShowEnterpriseReport" id="BCT-report" class="col-md-6 col-sm-12 mb-4 pl-2 pr-075">
            <div class="card boxshadow-card">
              <div class="card-header font-weight-bold font16">
                {{'analysis.title.bct' | translate}}</div>
              <div class="card-body">
                <ng-container *ngIf="showChartBCT; else chartNoData">
                  <highcharts-chart id="bctPieChart" [Highcharts]="highcharts" [options]="chartOptionsBCT"
                                    class="pie-chart-item">
                  </highcharts-chart>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- HĐ nhận từ đối tác -->
          <div *ngIf="isShowPartnerReport" id="partner-report" class="col-12"
               style="padding-right: 0.75rem;">
            <div class="card boxshadow-card partner-main">
              <div class="card-header font-weight-bold font16">
                {{'analysis.title.partner' | translate}}</div>
              <div class="card-body">
                <div class="row flex-grow-1">

                  <div class="col-md-3 col-6 pr-sm-12 mb-3 mb-md-0 contractTab"
                       [ngStyle]="{'padding-right': '0.75rem'}">
                    <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                         (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.WAIT_SETUP_FLOW)">
                      <div class="card-contract">
                        <div>
                          <div class="round-fa-calendar bg-ff7840 icon-image">
                            <ng-container *ngTemplateOutlet="iconWait"></ng-container>
                          </div>
                        </div>
                        <div>
                          <div
                            class="card-contract__value cursor-pointer"
                            style="color: #ff7840">{{documentEnterpriseReceive.waitSetSignFlow}}</div>
                          <div
                            class="card-contract__title contractNhan ">{{'analysis.analysis_report_partner.status.wait_setup_flow' | translate}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 col-6 mb-3 mb-md-0 contractTab" style="padding-right: 0.75rem;">
                    <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                         (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.PROCESSING)">
                      <div class="card-contract">
                        <div>
                          <div class="round-fa-calendar bg-2f75D0 icon-image">
                            <ng-container *ngTemplateOutlet="iconProcess"></ng-container>
                          </div>
                        </div>
                        <div>
                          <div
                            class="card-contract__value cursor-pointer"
                            style="color: #2f75D0">{{documentEnterpriseReceive.processing}}</div>
                          <div
                            class="card-contract__title contractNhan1 ">{{'analysis.analysis_report_partner.status.processing' | translate}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 col-6 pr-sm-12 contractTab"
                       [ngStyle]="{'padding-right': '0.75rem'}">
                    <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                         (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.SIGNED)">
                      <div class="card-contract">
                        <div>
                          <div class="round-fa-calendar bg-15b98c icon-image">
                            <ng-container *ngTemplateOutlet="iconResolve"></ng-container>
                          </div>
                        </div>
                        <div>
                          <div class="card-contract__value cursor-pointer"
                               style="color: #15b98c">{{documentEnterpriseReceive.signed}}</div>
                          <div
                            class="card-contract__title contractNhan1 ">{{'analysis.analysis_report_partner.status.signed' | translate}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 col-6 contractTab" style="padding-right: 0.75rem;">
                    <div class="card card-body-content-custom cursor-pointer h-100 h-100-1111"
                         (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.REJECTED)">
                      <div class="card-contract">
                        <div>
                          <div class="round-fa-calendar bg-ee0033 icon-image">
                            <ng-container *ngTemplateOutlet="iconReject"></ng-container>
                          </div>
                        </div>
                        <div>
                          <div class="card-contract__value cursor-pointer"
                               style="color: #ee0033">{{documentEnterpriseReceive.rejected}}</div>
                          <div
                            class="card-contract__title contractNhan1">{{'analysis.analysis_report_partner.status.refused' | translate}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

    </div>
  </mat-card-content>
</mat-card>

<ng-template #iconWait>
  <div>
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5385_6703)">
        <path
          d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58332V1.41595H5.41666V3.58262H2.16666V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33332V8.99929H21.6667V23.0826Z"
          fill="white"/>
        <path
          d="M16.665 21.3249H9.33498C9.15107 21.3249 9.0018 21.1756 9.0018 20.9917C9.0018 20.8078 9.15107 20.6585 9.33498 20.6585H16.665C16.8489 20.6585 16.9982 20.8078 16.9982 20.9917C16.9982 21.1756 16.8489 21.3249 16.665 21.3249Z"
          fill="white"/>
        <path
          d="M15.9987 13.3284V11.9957H10.0014V13.3284C10.0014 14.6361 10.8933 15.5571 11.4318 15.9939C10.8933 16.4307 10.0014 17.3516 10.0014 18.6593V19.9921H11.001C11.001 19.9921 11.8576 17.993 13.0001 17.993C14.1425 17.993 14.9992 19.9921 14.9992 19.9921H15.9987V18.6593C15.9987 17.3516 15.1068 16.4307 14.5683 15.9939C15.1068 15.5571 15.9987 14.6361 15.9987 13.3284Z"
          fill="white"/>
        <path
          d="M16.665 11.3293H9.33498C9.15107 11.3293 9.0018 11.1801 9.0018 10.9961C9.0018 10.8122 9.15107 10.663 9.33498 10.663H16.665C16.8489 10.663 16.9982 10.8122 16.9982 10.9961C16.9982 11.1801 16.8489 11.3293 16.665 11.3293Z"
          fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_5385_6703">
          <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</ng-template>

<ng-template #iconProcess>
  <div>
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5385_6937)">
        <path
          d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58333V1.41595H5.41666V3.58262H2.16666V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33333V8.99929H21.6667V23.0826Z"
          fill="white"/>
        <path d="M18.4477 15.1266H7.55234" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_5385_6937">
          <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</ng-template>

<ng-template #iconResolve>
  <div>
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5385_7168)">
        <path
          d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58334V1.41595H5.41667V3.58262H2.16667V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33334V8.99929H21.6667V23.0826Z"
          fill="white"/>
        <g clip-path="url(#clip1_5385_7168)">
          <path
            d="M11.5 17.4176L9.76501 15.6826C9.57001 15.4876 9.25501 15.4876 9.06001 15.6826C8.86501 15.8776 8.86501 16.1926 9.06001 16.3876L11.15 18.4776C11.345 18.6726 11.66 18.6726 11.855 18.4776L17.145 13.1876C17.34 12.9926 17.34 12.6776 17.145 12.4826C16.95 12.2876 16.635 12.2876 16.44 12.4826L11.5 17.4176Z"
            fill="white"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5385_7168">
          <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
        </clipPath>
        <clipPath id="clip1_5385_7168">
          <rect width="12" height="12" fill="white" transform="translate(7 9.33264)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</ng-template>

<ng-template #iconReject>
  <div>
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5385_7400)">
        <path
          d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58332V1.41595H5.41666V3.58262H2.16666V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33332V8.99929H21.6667V23.0826Z"
          fill="white"/>
        <path
          d="M17.3377 12.367L16.4177 11.447L12.7705 15.0942L9.12333 11.447L8.20337 12.367L11.8506 16.0142L8.20337 19.6614L9.12333 20.5814L12.7705 16.9341L16.4177 20.5814L17.3377 19.6614L13.6905 16.0142L17.3377 12.367Z"
          fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_5385_7400">
          <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
</ng-template>

<ng-template #iconExclamation>
  <div>
    <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
  </div>
</ng-template>

<ng-template #chartNoData>
  <div class="no-data-chart"><img alt="time" src="./assets/images/no-data-chart.svg" width="100" height="100"><span>{{'analysis.no_data' | translate}}</span></div>
</ng-template>

<ng-template #chartSkeleton>
  <div class="chart-skeleton">
    <div class="skeleton-line w-40"></div>
    <div class="chart-skeleton-bars">
      <div class="skeleton-bar" *ngFor="let h of [45, 70, 55, 85, 60, 75, 50, 90, 65, 80, 58, 72]"></div>
    </div>
    <div class="skeleton-line w-70"></div>
  </div>
</ng-template>
